import { PLATFORM_SLUG } from '@core/constants/platform';

function toBoolean(value) {
  return value !== false && value !== 'false' && value !== 0;
}

function activePlatforms(platforms) {
  return Array.isArray(platforms)
    ? platforms.filter((platform) => toBoolean(platform?.is_active))
    : [];
}

function slugOf(platform) {
  return String(platform?.platform_slug || '')
    .trim()
    .toLowerCase();
}

function b2bPlatform(platforms) {
  return activePlatforms(platforms).find(
    (platform) => slugOf(platform) === PLATFORM_SLUG.ECOMMERCE_B2B,
  );
}

/**
 * True when a location's platforms (`/plugins/platform/locations/all` rows)
 * include an active ecommerce-b2b platform.
 * @param {object[]} platforms
 */
export function locationSupportsB2B(platforms) {
  return Boolean(b2bPlatform(platforms));
}

/**
 * `account_platform_id` of the ecommerce-b2b platform — the channel business
 * shoppers order on.
 * @param {object[]} platforms
 * @returns {string}
 */
export function getLocationB2BChannelId(platforms) {
  return String(b2bPlatform(platforms)?.account_platform_id || '').trim();
}

/**
 * @param {object} raw  /api/v1/locations item
 * @returns {import('@core/types').Location}
 */
export function toLocation(raw) {
  const latitude = raw.latitude ?? null;
  const longitude = raw.longitude ?? null;
  return {
    id: raw.location_id ?? raw.id,
    name: raw.name ?? '',
    address: raw.address ?? null,
    city: raw.address?.city ?? undefined,
    state: raw.address?.state ?? undefined,
    country: raw.address?.country ?? undefined,
    latitude: latitude != null ? Number(latitude) : undefined,
    longitude: longitude != null ? Number(longitude) : undefined,
    currencyCode: raw.currency_code ?? undefined,
    isActive: raw.is_active ?? true,
    isApproved: raw.is_approved ?? true,
    deliveryAvailable: raw.delivery_details?.delivery_available ?? false,
    pickupAvailable: raw.delivery_details?.pickup_available ?? false,
    deliverySlots: raw.delivery_details?.delivery_slots ?? raw.delivery_slots ?? null,
    timings: raw.timings ?? [],
    supportContact: raw.support_contact ?? null,
    raw,
  };
}
